import type { MobileBottomNavItems } from "./types";

import { StreamingIcons } from "@/assets/iconFont/streaming-icons";

const DEFAULT_BOTTOM_NAV: MobileBottomNavItems = [
  {
    iconName: StreamingIcons.HomeOutline,
    selectedIconName: StreamingIcons.HomeFilled,
    label: "Home",
  },
  {
    iconName: StreamingIcons.ChannelsOutline,
    selectedIconName: StreamingIcons.ChannelsFilled,
    label: "Channels",
  },
  {
    iconName: StreamingIcons.Search,
    label: "Search",
  },
  {
    iconName: StreamingIcons.Download,
    label: "Downloads",
  },
];

export { DEFAULT_BOTTOM_NAV };
